/* Moon Tide — scroll journey, flying fairy and cursor sparkles.
   Only transform/opacity are written per frame, and nothing is measured from
   the DOM while scrolling (positions are cached on load/resize). */
(function () {
  'use strict';
  var root = document.querySelector('[data-journey]');
  if (!root) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  var skies = Array.prototype.slice.call(root.querySelectorAll('[data-sky]'));
  var stops = skies.map(function (el) { return parseFloat(el.getAttribute('data-sky')); });
  var stars = root.querySelector('.journey__stars');
  var moon = root.querySelector('.journey__moon');
  var deep = root.querySelector('.journey__deep');
  var underwater = root.querySelector('.journey__underwater');
  var surface = root.querySelector('.journey__surface');
  var full = root.getAttribute('data-mode') === 'full';
  var SURFACE = 0.5; // scroll point where we break through the water
  var motes = root.querySelector('.journey__motes');
  var waves = {};
  root.querySelectorAll('[data-wave]').forEach(function (el) { waves[el.getAttribute('data-wave')] = el; });
  var fairy = document.querySelector('[data-fairy]');
  var layer = document.querySelector('[data-sparkle-layer]');

  var clamp = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };
  var ramp = function (p, a, b) { return clamp((p - a) / (b - a)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var set = function (el, transform, opacity) {
    if (!el) return;
    el.style.transform = transform;
    if (opacity !== undefined) el.style.opacity = opacity.toFixed(3);
  };

  /* ---------- Sparkles ---------- */
  var STAR = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 1c.7 6.6 4.4 10.3 11 11-6.6.7-10.3 4.4-11 11-.7-6.6-4.4-10.3-11-11 6.6-.7 10.3-4.4 11-11z"/></svg>';
  var COLOURS = ['#E8B86A', '#C9A57B', '#F2C97D', '#7FA7E0', '#9EC0F2'];
  var CURSOR_COLOURS = ['#FFFFFF', '#FFFFFF', '#EAF2FF', '#CFE0FF', '#B3CDF7'];
  function sparkle(x, y, opts) {
    if (!layer || reduceMotion || layer.childElementCount > 40) return;
    opts = opts || {};
    var el = document.createElement('span');
    var dot = opts.dot || Math.random() < 0.3;
    el.className = 'sparkle' + (dot ? ' sparkle--dot' : '') + (opts.twinkle ? ' sparkle--twinkle' : '');
    if (!dot) el.innerHTML = STAR;
    var size = opts.size || (dot ? 3 + Math.random() * 3 : 8 + Math.random() * 12);
    var spread = opts.spread || 40;
    el.style.cssText =
      '--x:' + x + 'px;--y:' + y + 'px;--s:' + size.toFixed(1) + 'px;' +
      '--dx:' + ((Math.random() - 0.5) * spread).toFixed(1) + 'px;' +
      '--dy:' + ((opts.fall ? 0.4 : -0.1) * spread + Math.random() * spread * 0.8).toFixed(1) + 'px;' +
      '--c:' + (opts.colours || COLOURS)[(Math.random() * (opts.colours || COLOURS).length) | 0] + ';' +
      '--tw:' + (180 + Math.random() * 220).toFixed(0) + 'ms;' +
      '--d:' + (opts.duration || 700 + Math.random() * 600).toFixed(0) + 'ms';
    el.addEventListener('animationend', function () { el.remove(); });
    layer.appendChild(el);
  }

  if (root.getAttribute('data-sparkles-enabled') !== 'false' && finePointer && !reduceMotion) {
    var lastX = 0, lastY = 0, lastT = 0;
    window.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var now = performance.now();
      if (Math.abs(e.clientX - lastX) + Math.abs(e.clientY - lastY) < 18 || now - lastT < 40) return;
      lastX = e.clientX; lastY = e.clientY; lastT = now;
      sparkle(e.clientX, e.clientY, { fall: true, twinkle: true, colours: CURSOR_COLOURS, dot: Math.random() < 0.2, duration: 900 + Math.random() * 700 });
    }, { passive: true });
    window.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      for (var i = 0; i < 10; i++) sparkle(e.clientX, e.clientY, { spread: 90, size: 10 + Math.random() * 10, twinkle: true, colours: CURSOR_COLOURS });
    }, { passive: true });
  }

  /* ---------- Panels drift up into place as they enter the viewport ---------- */
  var panels = document.querySelectorAll('.section > .container');
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var panelIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-inview'); panelIO.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px 12% 0px', threshold: 0 });
    panels.forEach(function (el) { panelIO.observe(el); });
  } else {
    panels.forEach(function (el) { el.classList.add('is-inview'); });
  }

  /* ---------- Parallax (positions cached; no layout reads while scrolling) ---------- */
  var parallax = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]')).map(function (el) {
    return { el: el, speed: parseFloat(el.getAttribute('data-parallax')), centre: 0 };
  });
  var docMax = 1, vh = window.innerHeight, vw = window.innerWidth;
  function measure() {
    vh = window.innerHeight; vw = window.innerWidth;
    docMax = Math.max(1, document.documentElement.scrollHeight - vh);
    parallax.forEach(function (item) {
      item.el.style.translate = '0 0';
      var r = item.el.getBoundingClientRect();
      item.centre = r.top + window.scrollY + r.height / 2;
    });
  }

  /* ---------- Scroll-driven scene ---------- */
  var target = 0, current = 0, ticking = false;
  var fairyX = -1, fairyY = 0, lastDust = 0, facingLeft = false, fairyW = 80;
  var useFairy = fairy && root.getAttribute('data-fairy-enabled') !== 'false' && !reduceMotion;
  if (fairy && !useFairy) fairy.remove();
  var activeSky = -1;

  function paintSky(p) {
    if (skies.length < 2) return;
    // Only the two keyframes around p are shown; everything else is hidden so it costs nothing.
    var k = 0;
    while (k < stops.length - 2 && p > stops[k + 1]) k++;
    var t = ramp(p, stops[k], stops[k + 1]);
    if (k !== activeSky) {
      skies.forEach(function (el, i) {
        var on = i === k || i === k + 1;
        el.style.visibility = on ? 'visible' : 'hidden';
        if (i === k) el.style.opacity = '1';
      });
      activeSky = k;
    }
    skies[k + 1].style.opacity = t.toFixed(3);
  }

  function paintSimple(p) {
    // Other pages: the night sky, moon and a painted horizon that gently rises as you read
    set(moon, 'translate3d(0,' + (p * vh * 0.18).toFixed(1) + 'px,0)', 1);
    set(waves.valley, 'translate3d(-50%,' + lerp(40, 22, p).toFixed(2) + '%,0)');
  }

  function paint(p) {
    if (!full) { paintSimple(p); return; }
    paintSky(p);

    // 1. Night: stars and the moon above a painted horizon of waves
    stars.style.opacity = (1 - ramp(p, 0.4, 0.5)).toFixed(3);
    var moonT = ramp(p, 0, 0.42);
    set(moon, 'translate3d(0,' + (moonT * vh * 0.42).toFixed(1) + 'px,0) scale(' + (1 - moonT * 0.12).toFixed(3) + ')', 1 - ramp(p, 0.38, 0.46));
    motes.style.opacity = Math.max(1 - ramp(p, 0.36, 0.46), ramp(p, 0.78, 0.9)).toFixed(3);

    // 2. The waves rise up and swallow the horizon (the moon sets behind them)
    set(waves.valley, 'translate3d(-50%,' + lerp(45, -8, ramp(p, 0, 0.36)).toFixed(2) + '%,0)', 1 - ramp(p, 0.46, 0.52));
    set(waves.sea, 'translate3d(-50%,' + lerp(100, -30, ramp(p, 0.26, SURFACE)).toFixed(2) + '%,0)', 1 - ramp(p, SURFACE + 0.02, SURFACE + 0.1));

    // 3. Breaking the surface: a bright band of water sweeps up and we're under the sea
    set(surface, 'translate3d(0,' + lerp(vh * 1.1, -vh * 0.6, ramp(p, SURFACE - 0.04, SURFACE + 0.05)).toFixed(1) + 'px,0)');
    var under = ramp(p, SURFACE - 0.01, SURFACE + 0.05);
    underwater.style.opacity = under.toFixed(3);
    underwater.style.visibility = under > 0 ? 'visible' : 'hidden';

    // 4. Underwater: the surface ripples above, currents swirl in from the corners
    var topT = ramp(p, SURFACE, SURFACE + 0.08), topOut = ramp(p, 0.64, 0.95);
    set(waves.top, 'translate3d(-50%,' + (lerp(-80, -30, topT) - topOut * 45).toFixed(2) + '%,0)', 1);
    var tl = ramp(p, 0.56, 0.68) * (1 - ramp(p, 0.8, 0.9));
    set(waves.tl, 'translate3d(' + lerp(-70, -12, tl).toFixed(2) + '%,' + lerp(-70, -6, tl).toFixed(2) + '%,0)', Math.min(1, tl * 1.6));
    var br = ramp(p, 0.62, 0.74) * (1 - ramp(p, 0.86, 0.96));
    set(waves.br, 'translate3d(' + lerp(70, 8, br).toFixed(2) + '%,' + lerp(70, 6, br).toFixed(2) + '%,0)', Math.min(1, br * 1.6));

    // 5. The deep sea: glowing jellyfish
    deep.style.opacity = ramp(p, 0.72, 0.86).toFixed(3);
  }

  function paintParallax(scrollY) {
    for (var i = 0; i < parallax.length; i++) {
      var item = parallax[i];
      var offset = (item.centre - scrollY - vh / 2) * -item.speed;
      if (Math.abs(offset) > vh) continue;
      item.el.style.translate = '0 ' + offset.toFixed(1) + 'px';
    }
  }

  function placeFairy(p, now) {
    var narrow = vw < 700;
    var x = vw * (0.5 + (narrow ? 0.32 : 0.4) * Math.sin(p * Math.PI * 5 + 0.6));
    var y = vh * (0.34 + 0.24 * Math.sin(p * Math.PI * 3.4));
    if (fairyX >= 0) {
      var dx = x - fairyX;
      if (Math.abs(dx) > 0.6 && (dx < 0) !== facingLeft) { facingLeft = dx < 0; fairy.classList.toggle('is-left', facingLeft); }
      var moved = Math.abs(dx) + Math.abs(y - fairyY);
      if (moved > 2 && now - lastDust > 70) {
        lastDust = now;
        sparkle(x + (facingLeft ? 12 : -12), y + 8, { dot: Math.random() < 0.6, spread: 26, fall: true, duration: 1000 });
      }
    }
    fairyX = x; fairyY = y;
    fairy.style.transform = 'translate3d(' + (x - fairyW / 2).toFixed(1) + 'px,' + (y - fairyW / 2).toFixed(1) + 'px,0)';
  }

  function frame(now) {
    ticking = false;
    var scrollY = window.scrollY;
    target = clamp(scrollY / docMax);
    // Ease towards the scroll position so the scene and fairy glide rather than jump
    current = reduceMotion ? target : current + (target - current) * 0.14;
    if (Math.abs(target - current) < 0.0005) current = target;
    paint(current);
    if (!reduceMotion) paintParallax(scrollY);
    if (useFairy) placeFairy(current, now || performance.now());
    if (current !== target) request();
  }
  function request() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', function () { measure(); if (fairy) fairyW = fairy.offsetWidth; request(); });
  window.addEventListener('load', function () { measure(); request(); });
  measure();
  if (fairy) fairyW = fairy.offsetWidth;
  current = target = clamp(window.scrollY / docMax);
  frame();
})();
